import { render, staticRenderFns } from "./PortalTicket.vue?vue&type=template&id=4191c087&scoped=true&"
import script from "./PortalTicket.vue?vue&type=script&lang=js&"
export * from "./PortalTicket.vue?vue&type=script&lang=js&"
import style0 from "./PortalTicket.vue?vue&type=style&index=0&id=4191c087&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191c087",
  null
  
)

export default component.exports